<template>
    <div class="home_wrap">

        <!-- 头部 -->
        <div class="red_top_bg">
            <div class="menu-btn" @click="$router.push('/user')">
                <img src="../images/home/menu.png" style="height:20px;" alt="">
            </div>
            <div class="top_title" @click="closeGame()">
                <img src="../images/logo/logo.png" style="width: 100%; height: 24px;" />
            </div>
            <div class="login-register" v-show="!userbalance">
                <div class="login-btn" @click="$parent.login()">Entrar</div>
                <div class="register-btn" @click="$parent.register()">Registro</div>
            </div>
            <div class="user-balance" v-show="userbalance && !show_game_box">
                <div class="bnumber">
                    <img class="jinbi" src="../images/home/jinbi.png" />
                    <span class="balance">{{ userbalance }}</span>
                </div>

                <div class="recharge-wrap" @click="$router.push('/invest')">
                    <img class="recharge-img" src="../images/home/recharge.png" />
                </div>
                <img class="head_image" @click="showUserinfo = true;" src="../images/avt.png" />
            </div>
        </div>

        <!-- 轮播图 -->
        <van-swipe :autoplay="3000" class="swiper-container">
            <van-swipe-item v-for="index in ['01', '02']" :key="index">
                <router-link :to="'#'" style="padding:10px;overflow:hidden;">
                    <img :src="require('../images/banner/banner' + index + '.png')" style="border-radius:10px;" />
                </router-link>
            </van-swipe-item>

        </van-swipe>

        <!-- 滚动通知 -->
        <div class="notice_root">
            <img class="notice_icon" src="../images/home/notice.png" alt="">
            <div class="container">
                <van-notice-bar style="width:100%;padding-left: 0;" color="#84A559" background="none" scrollable
                    :text="notice" />
            </div>

        </div>

        <!-- 分类 -->
        <div class="work_box">
            <div class="category-item" @click="category = 'hot'">
                <div v-if="category == 'hot'" class="cg-bg-hot"></div>
                <div v-else class="cg-bg"></div>
                <span :class="category == 'hot' ? 'ci-des cdactive' : 'ci-des'">Popular</span>
            </div>
            <div class="category-item" @click="category = 'PG'">
                <div v-if="category == 'PG'" class="cg-pg-hot"></div>
                <div v-else class="cg-pg"></div>
                <span class="ci-des">PG Slots</span>
            </div>
            <div class="category-item" @click="category = 'JDB'">
                <div v-if="category == 'JDB'" class="cg-jdb-hot"></div>
                <div v-else class="cg-jdb"></div>
                <span class="ci-des">JDB Slots</span>
            </div>
            <div class="category-item" @click="category = 'TADA'">
                <div v-if="category == 'TADA'" class="cg-tada-hot"></div>
                <div v-else class="cg-tada"></div>
                <span class="ci-des">TADA</span>
            </div>
            <div class="category-item" @click="category = 'SPRIBE'">
                <div v-if="category == 'SPRIBE'" class="cg-spribe-hot"></div>
                <div v-else class="cg-spribe"></div>
                <span class="ci-des">SPRIBE</span>
            </div>
        </div>


        <!-- 搜索 -->
        <div class="search-wrap" v-show="false">
            <input class="input-keyword" type="text" v-model="keyword" :placeholder="$t('请输入游戏名称')">
            <img class="simg" src="../images/home/s_a.png" alt="">
        </div>

        <!-- 游戏列表 -->
        <div class="new-list" v-for="(game, idx) in all_game_list" :key="idx"
            :style="idx == all_game_list.length - 1 ? 'margin-bottom:0rem;padding-bottom:0rem;' : ''">
            <div class="c-sm-des">
                <!-- <img src="../images/home/hot_a.png" class="sec-img"> -->
                <span class="sec-title">{{ game.origin }}</span>
            </div>
            <div class="game-list">
                <div class="game-item" v-for="(item, index) in game.game_list" :key="index"
                    @click="playGame(item.game_id, item.origin, item.id)" v-show="index < max_show">
                    <div class="innerbox">
                        <img v-if="item.status == 'normal'" class="game-collect" src="../images/collect/collect_green.png"
                            alt="" @click.stop="cancelCollect(item)" />
                        <img v-if="item.status == 'hidden'" class="game-collect" src="../images/collect/collect_black.png"
                            alt="" @click.stop="addCollect(item)" />
                        <img :class="item.origin == 'PG' ? 'game-img' : 'game-img2'" :src="item.img" alt="" />
                        <div class="game-name">{{ item.game_name }}</div>
                    </div>


                </div>
            </div>
            <div class="show_more" v-show="game.game_list.length > 6" @click="max_show += 6">Mostre mais ⇊</div>
        </div>




        <van-dialog v-model="show_tc" :confirmButtonText="'Receber'" :confirmButtonColor="'#fff'" :showCancelButton="true"
            :cancelButtonText="'Mais Tarde'" :closeOnClickOverlay="true" :beforeClose="beforeClose">
            <div class="popup_top">
                <div class="popup">{{ alter_notice }}</div>
            </div>
        </van-dialog>
        <div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
            <img class="kefu_img" src="../images/index/kefu.png" />
        </div>

        <div class="game-box" id="bigBox" v-show="show_game_box">
            <!-- <iframe :src="game_url" frameborder="0" id="myiframe"></iframe> -->
        </div>



        <div v-show="showUserinfo" @click="showUserinfo = false">
            <userInfo :username="username" :level="level" :total_bet_amount="total_bet_amount"
                :sub_level_amount="sub_level_amount"></userInfo>
        </div>



        <div class="rollscreen">
            <div class="rs_header">
                <span class="juid">Jogos</span>
                <span class="juid">Slot</span>
                <span class="juid">ID</span>
                <span class="juid">Aposta</span>
                <span class="juid">Bônus</span>
            </div>
            <vue-seamless-scroll :data="listData" class="warp">
                <ul class="rolling_wrap">
                    <li v-for="(item, index) in listData" :key="index">
                        <img :src="item.img" alt="" class="jackimg">
                        <span class="juid">{{ item.game_type.toUpperCase() }} Slot</span>
                        <span class="juid">{{ item.user_id }}</span>
                        <span class="juid">R${{ item.bet_amount }}</span>
                        <span class="juid" :class="item.win_amount>=50?'jactive':'jlow'">R${{ item.win_amount }}</span>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>

        <!-- <div class="daily-gift2" @click="getAirdrop">
            <img src="../images/item/box.gif" class="baoxiang" alt="" width="100">
            <span class="cot">{{ timeStr }}</span>
        </div> -->
        <!-- <img src="../images/item/gift.png" @click="$router.push('/reward')" class="daily-gift" alt="" width="100"> -->


        <img src="../images/home/download.png" @click="download()" class="download" alt="" width="100">

        <img src="../images/home/telegram.png" @click="joinTheGroup()" class="telegram" alt="" width="100">

        <img src="../images/home/service.png" @click="goSupport()" class="service" alt="" width="100">




        <ft></ft>
    </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import Vue from "vue";
import Fetch from "../../utils/fetch";
import userInfo from "../../components/userInfo.vue";
import { NoticeBar } from 'vant';
import ft from "../../components/ft.vue"
import { Swipe, SwipeItem, Icon, Progress, Dialog, Field } from "vant";

Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(NoticeBar);

export default {
    name: "Index",
    components: {
        VanSwipe: Swipe,
        VanSwipeItem: SwipeItem,
        userInfo: userInfo,
        ft: ft,
        vueSeamlessScroll
    },
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            myBaners: [{ img: "../images/home/banner01.png", url: "" }],
            show_kefu: true,
            msg_show: false,
            loading: false,
            icon: [],
            data: {
                item1: { show: true },
                item2: { show: true },
                item3: { show: true },
            },
            islogin: false,
            isapp: false,
            show_tc: false,
            tc_content: "",
            gameList: [],
            show_game_box: false,
            game_url: "",
            gameType: 0,
            username: null,
            userbalance: null,
            all_game_list: [],
            keyword: "",
            notice: "",
            alter_notice: "",
            head_image: '',
            showUserinfo: false,
            level: 0,
            total_bet_amount: 0,
            sub_level_amount: 0,
            group_service: "",
            service: "",
            leftCount: 0,
            secondsUntilNextHour: 0,
            timeStr: "00:00:00",
            time_id: null,
            is_ban: 0,
            evtSource: null,
            category: "hot",
            max_show: 6,
            listData: [],
            classOption: {
                singleHeight: 30
            },
        };
    },
    watch: {
        keyword: function (newn, old) {
            //console.log(newn, old);
            this.gameList = [];
            this.all_game_list.forEach(item => {
                if (item.game_name.toLowerCase().search(newn.toLowerCase()) != -1) {
                    this.gameList.push(item);
                }
            })
        },
        category: function (newn, old) {
            this.max_show = 6;
            this.gameList = [];
            this.getGameList();

        },
    },
    created() {
        this.$parent.footer("index");
        this.getNotice();



    },
    mounted() {
        this.getAlterNotice();
        this.getJackpot();
        //this.AirdropCount();
        let code = this.$route.query.code;
        //console.log(code);
        if (code) {
            localStorage.setItem('code', code);
            this.$parent.register();


        } else {
            let idx = window.location.href.indexOf("code%3D");
            let url_code = "";
            if (idx != -1) {
                url_code = window.location.href.substring(idx + 7, idx + 13)
                console.log(url_code);
            }
            if (url_code) {
                localStorage.setItem('code', url_code);
                this.$parent.register();
                //this.$router.push({ path: '/register', query: { code: url_code } })
            }

        }
        this.getUserInfo();

        this.getGameList();

        Fetch('/user/getUserInfoApi2').then((r) => {
            this.service = r.data.service;
            this.group_service = r.data.group_service;
        });


    },
    destroyed() {
        clearInterval(this.time_id);
    },
    methods: {
        getJackpot() {
            this.listData = [];
            Fetch('/index/get_jackpot').then((r) => {
                this.listData = r.data;
            });
        },
        download() {
            var ua = navigator.userAgent.toLowerCase(),
                iphoneos = (ua.match(/iphone os/i) == "iphone os") || (ua.match(/iph os/i) == "iph os") || (ua.match(/ipad/i) == "ipad"),
                android = (ua.match(/android/i) == "android") || (ua.match(/adr/i) == "adr") || (ua.match(/android/i) == "mi pad");
            let andurl = "http://154.39.152.65/app/22ola.apk";
            var iosurl = 'http://154.39.152.65/app/ios.mobileconfig';     //苹果端下载地址
            if (iphoneos) {
                window.location.href = iosurl;
            } else {
                console.log(andurl);
                window.location.href = andurl;
            }

        },
        cancelCollect(item) {
            Fetch('/game_collection/cancel_collect', {
                type: item.origin,
                game_id: item.id
            }).then((r) => {
                if (r.code == 1) {
                    this.getGameList();
                } else {
                    // this.show_tc = false;
                }
            });
            return false;
        },
        getAirdrop() {
            Fetch('/airdrop/getAirdrop', {}).then((res) => {
                //console.log(r);
                this.$toast({
                    background: "#07c160",
                    message: res.msg,
                    duration: 5000,
                });
                if (res.code == 1) {
                    setTimeout(() => {
                        this.getUserInfo();
                    }, 2500);
                }
            });
        },
        //获取空投时间和剩余的数量
        AirdropCount() {

            Fetch('/airdrop/getLeftTimeAndCount', {}, {}, false).then((res) => {
                //console.log(res);
                if (res.code == 1) {
                    this.secondsUntilNextHour = res.data.secondsUntilNextHour;
                    this.leftCount = res.data.leftCount;
                    let seconds = this.secondsUntilNextHour;
                    this.time_id = null;
                    clearInterval(this.time_id);
                    this.time_id = setInterval(() => {
                        if (seconds <= 0) {
                            clearInterval(this.time_id);
                            this.AirdropCount();
                            return;
                        }
                        let hours = Math.floor(seconds / 3600);
                        let minutes = Math.floor((seconds % 3600) / 60);
                        let remainingSeconds = seconds % 60;
                        this.timeStr = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
                        //console.log(this.timeStr)
                        seconds--;
                    }, 1000);
                }
            });
        },
        addCollect(item) {
            Fetch('/game_collection/add_collect', {
                type: item.origin,
                game_id: item.id
            }).then((r) => {
                if (r.code == 1) {
                    this.getGameList();
                } else {
                    // this.show_tc = false;
                }
            });
            return false;
        },

        beforeClose(action, done) {
            console.log(action)
            // if (action == "confirm") this.$router.push("/register");
            if (action == "overlay") this.show_tc = false;
            if (action == "confirm") {
                this.show_tc = false;
                localStorage.setItem('notify', this.alter_notice);
                this.joinTheGroup();
            }
            if (action == "cancel") {
                this.show_tc = false;
                //localStorage.setItem('notify', this.alter_notice);
            }


        },
        getUserInfo() {
            Fetch('/user/is_login').then((r) => {

                if (r.data) {
                    this.username = r.data.username;
                    this.userbalance = r.data.money;
                    this.head_image = r.data.avatar;
                    this.level = r.data.level;
                    this.total_bet_amount = r.data.total_bet_amount;
                    this.sub_level_amount = r.data.sub_level_amount;
                    this.is_ban = r.data.is_rob;

                } else {
                    // this.show_tc = false;
                }


            });
        },
        getGameList() {
            Fetch("/Game/getGameList", {
                type: this.category,
            }).then((res) => {
                this.all_game_list = res.data;
            });
        },
        getPGHtml(game_id) {
            return new Promise((resolve, reject) => {
                Fetch('/demo/getPGHtml', { game_id: game_id, token: localStorage.getItem("token") }, {}, true).then(res => {
                    resolve(res);
                })
            })

        },
        getJDBtoken(gameId) {
            return new Promise((resolve, reject) => {
                Fetch('/jdb_game/jdbtoken', { id: gameId }, false, false).then(res => {
                    resolve(res);
                })
            })

        },
        getJiliUrl(gameId) {
            return new Promise((resolve, reject) => {
                Fetch('/jili/game_url', { id: gameId }, false, false).then(res => {
                    if (res.code == 1) resolve(res);
                    resolve("https://www.google.com");
                })
            })

        },
        getAlterNotice() {
            Fetch("/user/alter_notice", {
            }).then((res) => {
                this.alter_notice = res.data;
                if (localStorage.getItem('notify') == res.data) {
                    this.show_tc = false;
                } else {
                    this.show_tc = true;
                }
            });
        },
        joinTheGroup() {
            window.location.href = this.group_service;
        },
        goSupport() {

            //弹窗,使用WHATSAPP还是TELEGRAM
            // Dialog.confirm({
            //     // title: "服务类型",
            //     message: "Telegram / WhatsApp",
            //     showConfirmButton: true,
            //     showCancelButton: true,
            //     confirmButtonText: "Telegram",
            //     cancelButtonText: "WhatsApp",
            //     className: "mydialog"
            // }).then(() => {

            //     window.location.href = this.service;
            // }).catch(() => {

            // });
            window.location.href = this.service;

        },
        getNotice() {
            Fetch("/user/notice", {
            }).then((res) => {
                this.notice = res.data;
            });

        },
        async playGame(gameId, origin, jdb_game_id) {


            if (!this.username) {
                this.$parent.login();
                return;
            }
            else {
                //被后台禁止游戏了
                if (this.is_ban) {
                    this.$toast({
                        background: "#07c160",
                        message: "Sua conta atual ainda não ativou as funções do jogo, entre em contato com seu gerente",
                        duration: 5000,
                    });
                    return;
                }
                if (this.userbalance < 0.4) {
                    return this.$router.push("/invest");
                }
            }


            //玩游戏前 需要先判断一下是PG的游戏还是JDB的游戏
            if (origin == "JDB") {
                //先获取一下游戏的链接
                let resp = await this.getJDBtoken(jdb_game_id);
                return this.launchJDB(resp.data);

            }

            if (origin == "TADA") {
                //先获取一下游戏的链接
                let resp = await this.getJiliUrl(gameId);
                return this.launchJDB(resp.data);

            }


            //PG
            if (origin == "PG") {
                this.show_game_box = true;
                var iframe = document.createElement("iframe");
                iframe.setAttribute("height", "100%");
                iframe.setAttribute("width", "100%");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("scrolling", "no");
                iframe.setAttribute("id", "myiframe");
                let l = localStorage.getItem("lang");
                let game_l = "pt";
                if (l == "pt_br") game_l = "pt";
                if (l == "en_us") game_l = "en";
                if (l == "zh_cn") game_l = "zh";
                this.game_url = await this.getPGHtml(gameId);
                iframe.addEventListener("load", function () {
                    console.log("iframe loaded!");
                });
                var bigBox = document.getElementById("bigBox");
                bigBox.appendChild(iframe);
                iframe.contentWindow.document.write(this.game_url);
            }


        },
        launchJDB(url) {
            this.show_game_box = true;
            var iframe = document.createElement("iframe");
            iframe.setAttribute("height", "100%");
            iframe.setAttribute("width", "100%");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("scrolling", "no");
            iframe.setAttribute("id", "myiframe");
            iframe.setAttribute("src", url);
            iframe.addEventListener("load", function () {
                console.log("iframe loaded!");
            });
            var bigBox = document.getElementById("bigBox");
            bigBox.appendChild(iframe);
        },
        closeGame() {
            document
                .getElementById("bigBox")
                .removeChild(document.getElementById("myiframe"));
            this.show_game_box = false;
            this.game_url = "";

            //重新获取用户的余额
            this.getUserInfo();
        },
        createIframe(content) {
            this.show_game_box = true;
            var iframe = document.createElement("iframe");
            iframe.setAttribute("height", "100%");
            iframe.setAttribute("width", "100%");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("scrolling", "no");
            iframe.setAttribute("id", "myiframe");
            iframe.addEventListener("load", function () {
                console.log("iframe loaded!");
            });
            var bigBox = document.getElementById("bigBox");
            bigBox.appendChild(iframe);
            iframe.contentWindow.document.write("<script>alert(1); window.location.href = " + content + "");
        },
    },
};
</script>

<style lang="less" scoped>
.warp {
    // border: 1px solid #84A559;
    // border-radius: 0.3rem;
    height: 270px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    ul {
        list-style: none;
        padding: 0;
        margin: 0 auto;

        li {
            padding: 0 0.2rem;
            height: 40px;
            line-height: 40px;
            margin-bottom: 0.25rem;
            display: flex;
            justify-content: space-between;
            font-size: 15px;
            color: white;
            align-content: center;
            align-items: center;
            background: linear-gradient(90deg, #213743, #232f39 9.04%, #292e27 17.64%, #557086 73.44%, #213743);
            border-left: 1px solid var(--separator);
            color: #fff;

        }

        .jackimg {
            height: 30px;
            width: 30px;
        }

        .juid {
            color: #83ac4e;
            font-size: 0.35rem;
            font-weight: 700;
        }
        .jactive{
            color: #fbde52;
        }
        .jlow{
            color: #3ba00e;
        }
    }
}

.rs_header {
    padding: 0 0.2rem;
    height: 40px;
    line-height: 40px;
    margin-bottom: 0.25rem;
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: white;
    align-content: center;
    align-items: center;
    background: linear-gradient(90deg, #213743, #232f39 9.04%, #292e27 17.64%, #557086 73.44%, #213743);
    border-left: 1px solid var(--separator);
    color: #fff;
    .juid{
        color: #c3d9a8;
        // color: rgb(210, 207, 207);
        font-weight: 700;
        font-family: cursive;
    }
}

.rollscreen {
    width: 96%;
    margin: 5px auto;
    padding: 5px 10px;
}

.van-dialog {
    background: #fff;
    border: 1px solid #84A559;
}

/deep/ .van-button--default {
    background: #84a559b3 !important;
    ;
}

.popup_top {
    color: #84A559;
    padding: 0.5rem;
}

.popup {
    line-height: 0.5rem;
}

.category-item>div {
    width: 0.5rem;
    height: 0.7rem !important;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
}

.category-item .cg-jdb-hot {
    width: 2rem !important;
    background-image: url("../images/home/jdb_a.png");
}

.category-item .cg-jdb {
    width: 2rem !important;
    background-image: url("../images/home/jdb.png");
}

.category-item .cg-tada-hot {
    width: 2rem !important;
    background-image: url("../images/home/tada_a.png");
}

.category-item .cg-tada {
    width: 2rem !important;
    background-image: url("../images/home/tada.png");
}

.category-item .cg-spribe-hot {
    width: 2rem !important;
    background-image: url("../images/home/spribe_a.png");
}

.category-item .cg-spribe {
    width: 2rem !important;
    background-image: url("../images/home/spribe.png");
}

.category-item .cg-pg-hot {
    width: 2rem !important;
    background-image: url("../images/home/pg_a.png");
}

.category-item .cg-pg {
    width: 2rem !important;
    background-image: url("../images/home/pg.png");
}

.cg-bg-hot {
    width: 2rem !important;
    background-image: url("../images/home/hot_a.png");
}

.cg-bg {
    width: 2rem !important;
    background-image: url("../images/home/hot.png");
}

.sec-title {
    color: #84A559;
    font-size: 14px;
    line-height: 0.6rem;
    margin-left: 0.25rem;
}

.c-sm-des {
    width: 96%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.sec-img {
    width: 0.8rem;
    height: 0.6rem;
    margin-left: 0.2rem;
}

.ci-des {
    display: block;
    color: #84A559;
    margin-top: 0.2rem;
    margin-bottom: 5px;
    font-size: 0.3rem;
}

.cdactive {
    color: #98E436 !important;
}

.ci-img {
    display: block;
    width: 40px;
    height: 40px;
}

.category-item {
    width: 20%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 5px 0;
}

.menu-btn {
    float: left;
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}


body .mydialog {
    background: red !important;
}


@keyframes my-btn {
    0% {
        transform: translateX(0rpx);
        transform: scale(.8);
    }

    50% {
        transform: translateX(20rpx);
        transform: scale(1);
    }

    100% {
        transform: translateX(0rpx);
        transform: scale(.8);
    }
}

.cot {
    text-align: center;
    color: gold;
    margin-top: -10px;
}

.baoxiang {
    width: 55px;
    display: block;
    margin: 0 auto;
    //margin-top: -10px;
}

.daily-gift2 {
    position: absolute;
    width: 65px;
    height: 75px;
    bottom: 195px;
    right: 10px;
    z-index: 2;
    background-color: #0d7319c7;
    border-radius: 15px;
    text-align: center;
}

.daily-gift {
    position: absolute;
    width: 65px;
    bottom: 55px;
    left: 10px;
    z-index: 2;
    animation: my-btn 2s ease-in infinite;
    background-color: #0d73196a;
    border-radius: 50%;
}

.login-btn {
    padding: 5px 8px;
    background-color: #84A559;
    color: #fff;
    height: 25px;
    display: flex;
    align-items: center;
    border-radius: 5px;
}

.register-btn {
    padding: 5px 8px;
    border: 1px solid #84A559;
    color: #84A559;
    height: 25px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    margin-left: 15px;
}

.login-register {
    float: right;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}

.top-right-div {
    padding: 0 5px;

    height: 50px;
    //width: 120px;
    //flex-wrap: wrap;
}

.goReachrge {
    display: block;
    // height: 40px;
    display: flex;
    align-items: center;
    padding: 5px 8px;
    //background-image: linear-gradient(to right, #a60092, #6011d0) !important;
    color: white;
    border-radius: 15px;
    font-size: 0.4rem;
    background: #224131;
}

.head_image {
    height: 30px;
    margin-left: 10px;
    border-radius: 50%;
    border: 1px solid #84A559;
}

.recharge-wrap {
    height: 25px;
    margin-left: 10px;
    border-radius: 0.24rem;
    box-shadow: 0 0 0 0 #dd234b;
    // width: 0.8rem;
    // height: 0.56rem;
    animation: WalletButtonBlink-JUR1h 2.5s ease 0s infinite normal none running;
}

.recharge-img {
    // width: 30px;
    height: 100%;
    // margin-left: 10px;
}

@keyframes WalletButtonBlink-JUR1h {

    10%,
    90% {
        transform: translate3d(-2px, 0, 0)
    }

    0% {
        transform: scale(1)
    }

    70% {
        box-shadow: 0 0 0 .2rem rgba(255, 49, 65, 0);
        transform: scale(1)
    }

    to {
        box-shadow: 0 0 rgba(255, 49, 65, 0);
        transform: scale(1)
    }
}

.jinbi {
    height: 24px;
    margin-right: 4px;
}

.bnumber {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    span {
        color: white;
        font-size: 0.38rem;
        font-weight: 700;
    }
}

.user-balance {
    width: 50%;
    height: 100%;
    float: right;
    display: flex;
    justify-content: right;
    align-items: center;
    align-content: center;
    z-index: 91;
    margin-right: 10px;
}

#myiframe {
    height: 100%;
    width: 100%;
    background: #3e4b58;
    position: absolute;
}

.game-box {
    position: fixed;
    top: 44px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999;
}

.game-img {
    position: absolute;
    width: 120%;
    height: 130%;
    left: -8%;
    top: -12%;
    z-index: 0;

}

.game-img2 {
    width: 100%;
    height: 100%;
    z-index: 0;
}

.game-collect {
    width: 18px;
    height: 18px;
    position: absolute;
    right: 1px;
    top: 1px;
    z-index: 1;
}

.game-item {
    width: 31%;
    height: 3.2rem;
    text-align: center;
    margin-bottom: 0.25rem;
    border-radius: 7.5px;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid #84A559;
    padding: 0.13rem;
}

.innerbox {
    border-radius: 3px;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.game-name {
    font-size: 12px;
    margin-top: 5px;
    position: absolute;
    z-index: 2;
    bottom: 0px;
    background-color: rgba(0, 0, 0, 0.5);
    background-color: #32b1b4;
    width: 100%;
    height: 25px;
    line-height: 25px;
    color: #fff;
}

.search-wrap {
    border: 1px solid #e5e5e557;
    height: 1rem;
    width: 94%;
    margin: 5px auto;
    border-radius: 10px;

}

.simg {
    width: 0.6rem;
    height: 0.6rem;
    float: right;
    margin-top: 0.18rem;
    margin-right: 0.3rem;
}

.input-keyword {
    width: 70%;
    height: 100%;
    color: white;
    font-size: 0.38rem;
    // text-align: center;
    float: left;
    text-indent: 10px;
}

.game-list {
    width: 96%;
    margin: 5px auto;
    padding: 5px 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

}

.new-list {
    position: relative;
    padding-bottom: 0.4rem;
}

.show_more {
    position: absolute;
    bottom: 0;
    color: #84A559;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    bottom: 0;
    text-align: center;
    font-size: 0.35rem;
}


.item-btn-left {
    float: left;
    padding: 8px 0;
    font-size: 0.35rem;
    //color: #AA976F;
    color: #a7a3a3;
}

.des-right-top {
    height: 20px;
    line-height: 20px;
    margin: 0 !important;
    font-size: 0.4rem;
    //font-weight: 700;
    color: #ffffff;
}

.des-right-mid {
    height: 20px;
    line-height: 20px;
    margin: 0 !important;
    font-size: 0.4rem;
    //font-weight: 700;
    //color: #826B47;
    color: #ffffff;
}

.des-right-btm {
    height: 20px;
    line-height: 20px;
    margin: 0 !important;
    font-size: 0.4rem;
    //font-weight: 700;
    //color: #826B47;
    color: #ffffff;
}

.des-left-btm {
    font-size: 0.4rem;
    color: #ad9d89;
}

.des-left-top {
    height: 30px;
    line-height: 30px;
    color: #e64d20;
    font-size: 0.7rem;
    font-weight: 700;
}

.des-left {
    width: 36%;
    height: 100%;
    //background: #07c160;
    text-align: center;
    float: left;
}

.des-right {
    width: 64%;
    height: 100%;
    //background: #07c160;
    //text-align: left;
    text-indent: 0.5rem;
    float: left;
}

.item_div4 {
    position: relative;
}

.progress-number {
    position: absolute;
    color: #947f59;
    left: 72%;
    height: 10px;
    top: -1px;
    margin: 0 !important;
    font-size: 12px;
    font-weight: 700;
}

.item-des {
    height: 60px;
    //background: #8d8d8f;
    width: 100%;
    margin: 0 !important;
}

/deep/ .van-cell {
    padding: 15px 26px;
}

.progress-div {
    width: 70%;
    height: 10px;
    border-radius: 5px;
    background: #e2dcd4;
    position: relative;
}

.progress-in {
    height: 10px;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 0;
    background: #3ba00e;
    width: 50%;
    margin: 0 !important;
}

.home_wrap {
    width: 100%;
    min-height: 100vh;
    background: url('../images/vip/sbg.png') repeat;

}

.top_title {
    text-align: center;
    font-size: 24px;
    display: flex;
    height: 100%;
    float: left;
    max-width: 28%;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
}

.red_top_bg {
    position: fixed;
    top: 0;
    z-index: 10;
    background-color: #000000;
    height: 50px;
    background-image: url("../images/home/top_bg.png");
}

.langbar {
    position: relative;
    margin-top: 44px;
    padding-top: 8px;
    height: 56px;
    background-color: #fff;
}

.search_box {
    width: 90%;
    height: 32px;
    background-color: #f6f6f6;
    border-radius: 17px;
    border: solid 1px #1989fa;
    margin: 8px auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px 0 14px;

    .fdj {
        width: 16px;
        height: 16px;
        background: url(../images/item/fdj.png) no-repeat center center;
        background-size: 100% 100%;
    }

    .search_inp {
        flex: 1;
        margin: 0 8px;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        height: 20px;
    }

    .clear_inp {
        width: 20px;
        height: 20px;
        background: url(../images/item/clear.png) no-repeat center center;
        background-size: 100% 100%;
    }
}

.swiper-container {
    width: 100%;
    height: 140px;
    border-radius: 10px;
    margin: 50px auto 0;

    .van-swipe-item {
        overflow: hidden;
    }

    a {
        float: left;
        width: 100%;
        height: 100%;
    }

    img {
        border-radius: 0;
        // margin-left: 2%;
        height: 100%;
        width: 100%;
    }
}

.work_box {
    background: rgba(0, 0, 0, 0.3);
    background-size: 100% 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    border-radius: 5px;
    width: 96%;
    margin: 8px auto;
}






.notice_root {
    height: 30px;
    overflow: hidden;
    position: relative;
    display: flex;
    margin: 0 auto;
    align-items: center;

    .container {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        display: flex;
        align-items: center;
        height: 100%;
    }
}

@keyframes scroll-left {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(-100%);
    }
}

.notice_root .notice_icon {
    overflow: hidden;
    position: relative;
    display: flex;
    // width: 25px;
    height: 18px;
    margin-left: 10px;
    margin-right: 10px;

}




.download {
    position: absolute;
    width: 1rem;
    bottom: 4.6rem;
    right: 0.3rem;
    z-index: 2;
}

.telegram {
    position: absolute;
    width: 1rem;
    bottom: 3.3rem;
    right: 0.3rem;
    z-index: 2;
}

.service {
    position: absolute;
    width: 1rem;
    bottom: 2rem;
    right: 0.3rem;
    z-index: 2;
    background: white;
    border-radius: 50%;

}

.van-button__text {
    background: white;
}
</style>
